module.exports = __webpack_public_path__ + "static/media/sass.c98c160d.png";